
import { computed, defineComponent, PropType, toRef } from 'vue';
import { useVModel } from 'vue-composable';
import { useStore } from '@/store';
import { Option } from '@/types';
import { User } from '@/types/app';
import { AuthorityLevels } from '@/enums';
import { createEnumerableEnum, addSpacesBetweenCapitals, useAddEditFormState } from '@/utils';
import { formDefaults } from '@/constants';
import AppModal from '@/components/modal/base/AppModal.vue';
import FilterableSelect from '@/components/form-controls/base/FilterableSelect.vue';
import EmailInput from '@/components/form-controls/base/EmailInput.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';

export default defineComponent({
  name: 'UserEditFormModal',
  emits: ['update:openState'],
  components: {
    AppModal,
    FilterableSelect,
    EmailInput,
    TextInput
  },
  props: {
    openState: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object as PropType<User>
    }
  },
  setup(props) {
    const isOpen = useVModel(props, 'openState');

    const enumerableAuthorityLevels = createEnumerableEnum(AuthorityLevels, keys => [
      keys.Admin,
      keys.Owner,
      keys.SuperAdmin,
      keys.User
    ]);

    const options = computed(() =>
      enumerableAuthorityLevels.map<Option<string | number>>(([key, value]) => ({
        label: addSpacesBetweenCapitals(key),
        value
      }))
    );

    const store = useStore();
    const userState = useAddEditFormState(
      toRef(props, 'user'),
      formDefaults.user,
      store.dispatch.users.update,
      store.dispatch.users.create
    );

    return {
      isOpen,
      enumerableAuthorityLevels,
      options,
      userState
    };
  }
});
